import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidWorkHard = data => {
    return validateWorkHardStep(get(data, ["workHard", "value"], "")) && !data.workHard.isValid
}

export const validateWorkHardStep = value => {
    return !isNull(value)
}

export const workHardData = {
    minimum: {
        value: "minimum",
        title: locales[window.userLang].minimum,
        a: 1.375,
    },
    normal: {
        value: "normal",
        title: locales[window.userLang].normal,
        a: 1.55,
    },
    maximum: {
        value: "maximum",
        title: locales[window.userLang].maximum,
        a: 1.725,
    },
    vervDecide: {
        value: "vervDecide",
        title: locales[window.userLang].verv_decide,
        a: 1.375,
    },
}

export const defaultFasting = false